module.exports = __webpack_public_path__ + "static/media/develpoer_balance.2a6d3fc6.png";